module.exports = __webpack_public_path__ + "static/media/microplastic-main-2.162cf9d8.png";